<template>
  <Modal v-model="model" sticky reset-drag-position title="通话详情" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="call_detail_pop" width="1200">
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="table_head">
        <table>
          <tr>
            <th class="font_style_set" :style="{width:(AICall?'9%':'8%')}">电话号码</th>
            <th class="font_style_set" :style="{width:(AICall?'9%':'8%')}">号码类型</th>
            <th class="font_style_set" :style="{width:(AICall?'9%':'8%')}">leg类型</th>
            <th class="font_style_set" :style="{width:(AICall?'9%':'8%')}">呼叫类型</th>
            <th class="font_style_set" style="width:7%;" v-if="!AICall">员工工号</th>
            <th class="font_style_set" style="width:6%;" v-if="!AICall">员工名称</th>
            <th class="font_style_set" :style="{width:(AICall?'14%':'13%')}">开始时间</th>
            <th class="font_style_set" :style="{width:(AICall?'11%':'10%')}">通话时长</th>
            <th class="font_style_set" :style="{width:(AICall?'8%':'7%')}">挂断方</th>
            <th class="font_style_set" :style="{width:(AICall?'8%':'7%')}">挂断编码</th>
            <th class="font_style_set" :style="{width:(AICall?'9%':'8%')}">挂机原因</th>
            <th class="font_style_set" :style="{width:(AICall?'11%':'10%')}" v-if="playBtnShow || downLoadBtnShow">录音文件</th>
          </tr>
        </table>
      </div>
      <div class="footer_style">
        <table class="table_head_footer">
          <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
            <td  :style="{width:(AICall?'9%':'8%')}" :class="{'font_style_set':true ,'telephone':item.legType==='AI呼叫'}" @click="openAIDetail(item.employeeMobile,item.legType)" :title="item.phone">{{item.phone}}</td>
            <td  :style="{width:(AICall?'9%':'8%')}" class="font_style_set" :title="item.numberType">{{item.numberType}}</td>
            <td  :style="{width:(AICall?'9%':'8%')}" class="font_style_set" :title="item.legType">{{item.legType}}</td>
            <td  :style="{width:(AICall?'9%':'8%')}" class="font_style_set" :title="item.callType">{{item.callType}}</td>
            <td  style="width:7%;" class="font_style_set" :title="item.agentNum" v-if="!AICall">{{item.agentNum}}</td>
            <td  style="width:6%;" class="font_style_set" :title="item.agentName" v-if="!AICall">{{item.agentName}}</td>
            <td  :style="{width:(AICall?'14%':'13%')}" class="font_style_set" :title="item.startTime">{{item.startTime}}</td>
            <td  :style="{width:(AICall?'11%':'10%')}" class="font_style_set" :title="item.callTime">{{item.callTime}}</td>
            <td  :style="{width:(AICall?'8%':'7%')}" :title="item.hangupDirection">{{item.hangupDirection}}</td>
            <td  :style="{width:(AICall?'8%':'7%')}" class="font_style_set" :title="item.hangupReasonCode">{{item.hangupReasonCode}}</td>
            <td  :style="{width:(AICall?'9%':'8%')}" class="font_style_set" :title="item.hangupReason">{{item.hangupReason}}</td>
            <td  :style="{width:(AICall?'11%':'10%')}" class="template_table_btn" v-if="playBtnShow || downLoadBtnShow">
              <el-button @click="playCallRecord(baseImgURL+item.recordFile)" :disabled="!item.recordFile" type="text" size="small" v-show="playBtnShow">播放</el-button>
              <el-button disabled v-if="!item.recordFile" style="margin-left: 0px;" type="text" size="small" v-show="downLoadBtnShow">下载</el-button>
              <a :href="baseURL+'common/downloadFile.json?type=0&addr='+item.recordFile" target="_blank" v-else class="down_file_a" v-show="downLoadBtnShow">下载</a>
            </td>
          </tr>
        </table>
      </div>
      <div class="music_play" v-if="showPlay">
        <audio controls="controls" id="autoPlayEqu0" controlsList="nodownload">
          <source :src="musicUrlOne"  type="audio/mpeg"/>
        </audio>
      </div>
      <playMusicPop  @closeRecordfile="closeRecordfile" :showRecordFile="showRecordFile" :recordFile="recordFile"></playMusicPop>
      <AICallDetail @closeCallDetail="closeFlowDetail" :showCallDetailPop="openFlowDetail" :callUuid="callUuid"></AICallDetail>
    </div>
  </Modal>
</template>
<script>
    import playMusicPop from '@/components/statisticsReportForm/detailedReportForm/PlayMusicPop.vue'
    import AICallDetail from "@/components/aiManager/AICallDetail"
    export default {
        name: "CallDetailPop",
        props: {
          showCallDetailPop:Boolean,
          callUuid:String,
          AICall: {
            type:Boolean,
            default:false
          }
        },
        components:{
          playMusicPop,
          AICallDetail
        },
        data(){
          return {
            model:false,
            showPlay:false,
            infoTableList:[],
            spinShow:false,
            musicUrlOne:'',
            baseMusicUrl:this.baseURL+"common/downloadFile.json?type=0&addr=",
            showRecordFile:false,
            recordFile:'',
            downMusicUrl:'',
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            playBtnShow:true,
            downLoadBtnShow:true,
            roleList: JSON.parse(localStorage.getItem('roleList')),
            openFlowDetail:false,
          }
        },
        methods:{
          cancel:function(){
            this.$emit("closeCallDetail",false);
          },
          playCallRecord:function (url) {
            this.showRecordFile=true;
            this.recordFile=url;
          },
          closeRecordfile:function(){
            this.showRecordFile=false;
          },
          initSearch:function (callUuid) {
            let that=this;
            this.spinShow=true;
            let param={
              callUuid:callUuid
            };
            this.$http.post("callrecords/doSelectOne.json",param) .then(function (res) {
              that.spinShow=false;
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.infoTableList=res.data.obj.list;
            });
          },
          openAIDetail(rwName,legType) {
            if (legType === 'AI呼叫') {
              this.openFlowDetail = true
            }
          },
          closeFlowDetail() {
            this.openFlowDetail = false
          }
        },
        watch:{
          showCallDetailPop:function () {
            this.model=this.showCallDetailPop;
            this.showPlay=false;
            this.musicUrlOne="";
            if(this.showCallDetailPop){
              this.initSearch(this.callUuid);
            }
            if (this.AICall) {
              this.playBtnShow = this.roleList['a_5-3-1'];
              this.downLoadBtnShow = this.roleList['a_5-3-2'];
            } else {
              this.playBtnShow = this.roleList['8_2-1-4-1']
              this.downLoadBtnShow = this.roleList['8_2-1-4-2']
            }
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/detailedReportForm/CallDetailPop.vue